import { deleteDoc, doc } from "firebase/firestore"
import { deleteObject, getStorage, listAll, ref } from "firebase/storage"
import { db } from "../firebase/config"

/**
 * Cleans up a Tape plate when its order is completed.
 * Only runs when the order machine is "Tape" — safe to call for any order.
 *
 * Steps:
 *  1. Deletes all files from Firebase Storage at tapePlates/{plateCode}/
 *  2. Deletes the plate document from tapePlatesList
 *
 * Viva and Arsoma plates are left untouched.
 *
 * @param {object} order - Full order object
 * @returns {Promise<void>}
 */
export const cleanupTapePlate = async (order) => {
  if (order?.selectedProduct?.machine !== "Tape") return

  const plateCode = order.selectedPlate?.code
  const plateId = order.selectedPlate?.id

  if (!plateCode || !plateId) return

  // 1. Delete all files in tapePlates/{plateCode}/
  try {
    const storage = getStorage()
    const folderRef = ref(storage, `tapePlates/${plateCode}`)
    const { items } = await listAll(folderRef)
    await Promise.all(items.map((fileRef) => deleteObject(fileRef)))
  } catch (err) {
    console.error(`[cleanupTapePlate] Storage cleanup failed for plate ${plateCode}:`, err)
  }

  // 2. Remove the plate document from tapePlatesList
  try {
    await deleteDoc(doc(db, "tapePlatesList", plateId))
  } catch (err) {
    console.error(`[cleanupTapePlate] Firestore delete failed for plate ${plateId}:`, err)
  }
}
